import Icon from '../components/Icon.vue'

Icon.register({"buysellads":{"width":1536,"height":1792,"paths":[{"d":"M915 1086h-294l147-551zM1001 1408h311l-324-1024h-440l-324 1024h311l383-314zM1536 416v960q0 118-85 203t-203 85h-960q-118 0-203-85t-85-203v-960q0-118 85-203t203-85h960q118 0 203 85t85 203z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/buysellads.js
// module id = +aP1
// module chunks = 1